import script from "./campaign-form.vue?vue&type=script&setup=true&lang=js"
export * from "./campaign-form.vue?vue&type=script&setup=true&lang=js"

import "./campaign-form.vue?vue&type=style&index=0&id=4c85d807&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c85d807"]])

export default __exports__